import { render, staticRenderFns } from "./AgendaItem.vue?vue&type=template&id=4fc0faf8&scoped=true&"
import script from "./AgendaItem.vue?vue&type=script&lang=js&"
export * from "./AgendaItem.vue?vue&type=script&lang=js&"
import style0 from "./AgendaItem.vue?vue&type=style&index=0&id=4fc0faf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0faf8",
  null
  
)

export default component.exports